import React, { useContext } from 'react'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined'
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined'
import HomeIcon from '@material-ui/icons/Home'
import TuneIcon from '@material-ui/icons/Tune'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import NavigationIcon from '@material-ui/icons/NavigationOutlined'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import PersonIcon from '@material-ui/icons/Person'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import WorkIcon from '@material-ui/icons/Work'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import ApartmentIcon from '@material-ui/icons/Apartment'
import ListAltIcon from '@material-ui/icons/ListAlt'
import NearMeIcon from '@material-ui/icons/NearMe'
import PropTypes from 'prop-types'
import { Popover } from '@material-ui/core'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import PropertyTypeFilter from '../PropertyTypeFilter/PropertyTypeFilter.js'
import SubmitClearFilters from '../SubmitClearFilters/SubmitClearFilters.js'
import FeaturesFilter from '../FeaturesFilter/FeaturesFilter'
import LocationFilters from '../LocationFilters/LocationFilters'
import AccountFilter from '../AccountFilter/AccountFilter'
import LoanFilter from '../LoanFilter/LoanFilter'
import SalesFilter from '../SalesFilter/SalesFilter'
import TenantInfoFilter from '../TenantInfoFilter/TenantInfoFilter'
import DistanceFilter from '../DistanceFilter/DistanceFilter'
import ListingStatusFilter from '../ListingStatusFilter/ListingStatusFilter'
import myContext from '../context/context'
import { getDateTimeRangeSelection, formatDate } from '../../../../Components/PropertySearch/Utility/Utility'

function FilterPopover(props) {
  // const [multiSelectRows, setmultiSelectRows] = useState({})
  const { searchCriteria } = useContext(myContext)

  const { name, filterName, startIcon, endIcon, btnVariant } = props
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const listOfIcons = {
    ArrowDropDownIcon: <ArrowDropDownIcon />,
    SaveOutlinedIcon: <SaveOutlinedIcon />,
    ListAltOutlinedIcon: <ListAltOutlinedIcon />,
    TuneIcon: <TuneIcon />,
    NavigationIcon: <NavigationIcon />,
    HomeIcon: <HomeIcon />,
    LocationOnIcon: <LocationOnIcon />,
    PersonIcon: <PersonIcon />,
    MoreHorizIcon: <MoreHorizIcon />,
    WorkIcon: <WorkIcon />,
    AccountBalanceIcon: <AccountBalanceIcon />,
    MonetizationOnIcon: <MonetizationOnIcon />,
    ApartmentIcon: <ApartmentIcon />,
    ListAltIcon: <ListAltIcon />,
    NearMeIcon: <NearMeIcon />
  }

  const listSearchCriterias = {
    'Distance': 'distanceFields',
    'Type': 'propertyTypeFields',
    'Listings': 'listingStatusFields',
    'Features': 'featureFields',
    'Sales': 'salesFields',
    'Location': 'locationFields',
    'Tenant Info': 'tenantInfoFields',
    'Loan': 'loanFields',
    'Account': 'accountFields'
  }

  const isCriteriaSelected = item => {
    let returnVal = false
    const criteriaCategory = listSearchCriterias[item]

    if (criteriaCategory) {
      if (searchCriteria[criteriaCategory].length > 0) {
        returnVal = true
      }
    }

    return returnVal
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  // const filterDialogToLoad = listOfFilter[filterName]
  const startIconToLoad = listOfIcons[startIcon]
  const endIconToLoad = listOfIcons[endIcon]

  const listOfFilter = {
    PropertyTypeFilter: <PropertyTypeFilter />,
    FeaturesFilter: <FeaturesFilter />,
    NearByLocationFiltersPopOver: <LocationFilters />,
    TenantInfoFilter: <TenantInfoFilter />,
    SalesFilter: <SalesFilter />,
    LoanFilter: <LoanFilter />,
    AccountFilter: <AccountFilter />,
    DistanceFilter: <DistanceFilter />,
    ListingStatusFilter: <ListingStatusFilter />
  }

  const getTypeName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.propertyTypeFields
      const lstPropertyTypes = searchCriteria.propertyTypeFields.filter(x => x.subtype === 'all')
      if (lstPropertyTypes.length > 0) {
        newName = `Type : ${lstPropertyTypes[0].propertytype}`
      } else {
        newName = `Subtype : ${firstItem.subtype}`
      }
    }

    return newName
  }
  const getLocationName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]
    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.locationFields
      const lstPropertyTypes = searchCriteria.locationFields.filter(x => x.locationValue === 'all')
      if (!lstPropertyTypes.length) {
        newName = `${firstItem.locationType} : ${firstItem.locationValue}`
      }
    }
    return newName
  }

  const getFeaturesName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.featureFields
      const { label, minValue, maxValue, isMinMax } = firstItem
      let inputValue = ''
      if (isMinMax) {
        inputValue = minValue !== '' ? `> ${minValue}` : `< ${maxValue}`
      } else {
        inputValue = `: ${minValue}`
      }
      newName = `${label} ${inputValue}`
    }

    return newName
  }

  const getListingsName = defaultName => {
    let newName = defaultName
    let inputValue
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.listingStatusFields
      newName = `Listing : ${firstItem.label}`
      if (firstItem.type === 'date') {
        if (firstItem.isStartEnd) {
          inputValue = firstItem.startValue !== '*' ? `> ${formatDate(firstItem.startValue)}` : `< ${formatDate(firstItem.endValue)}`
          newName = `${firstItem.label} ${inputValue}`
        } else {
          inputValue = firstItem.minValue !== '' ? `> ${formatDate(firstItem.minValue)}` : `< ${formatDate(firstItem.maxValue)}`
          newName = `${firstItem.label} ${inputValue}`
        }
      }
    }
    return newName
  }

  const getDistanceName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      let value = parseFloat(searchCriteria.distanceFields[0].value)
      newName = `${value} miles`
    }

    return newName
  }

  const getSalesName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.salesFields
      const { label, minValue, maxValue, startValue, endValue, isStartEnd } = firstItem
      let inputValue = ''

      if (isStartEnd) {
        inputValue = startValue !== '' ? `> ${startValue}` : `< ${endValue}`
      } else {
        inputValue = minValue !== '' ? `> ${minValue}` : `< ${maxValue}`
      }

      newName = `${label} ${inputValue}`
    }

    return newName
  }

  const getLoanName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.loanFields
      const { label, minValue, maxValue, startValue, endValue, isStartEnd, optionsList, value, propId } = firstItem
      let inputValue = ''

      if (isStartEnd) {
        inputValue = startValue !== '' ? `> ${startValue}` : `< ${endValue}`
      } else {
        inputValue = minValue !== '' ? `> ${(propId === "timeRange") ? getDateTimeRangeSelection(minValue) : minValue}` : `< ${(propId === "timeRange") ? getDateTimeRangeSelection(maxValue) : maxValue}`
      }
      if (optionsList) {
        inputValue = `: ${value}`
      }
      newName = `${(label ? label : firstItem.labelName)} ${inputValue}`
    }

    return newName
  }

  const getTenantInfoName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.tenantInfoFields
      const selectedValuess = searchCriteria.tenantInfoFields[0].groupList.filter(a => {
        return a.selected
      })
      newName = `${(firstItem.labelName)} : ${selectedValuess.length ? selectedValuess[0].val : ''}`
    }

    return newName
  }
  const getAccountName = defaultName => {
    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    if (showBadge(searchCriteriaName)) {
      const [firstItem] = searchCriteria.accountFields
      const { label, accountName } = firstItem

      newName = `${label}: ${accountName}`
    }

    return newName
  }

  const getFilterName = defaultName => {

    let newName = defaultName
    const searchCriteriaName = listSearchCriterias[newName]

    switch (searchCriteriaName) {
      case 'propertyTypeFields':
        newName = getTypeName(defaultName)
        break

      case 'featureFields':
        newName = getFeaturesName(defaultName)
        break

      case 'distanceFields':
        newName = getDistanceName(defaultName)
        break

      case 'accountFields':
        newName = getAccountName(defaultName)
        break

      case 'loanFields':
        newName = getLoanName(defaultName)
        break

      case 'salesFields':
        newName = getSalesName(defaultName)
        break

      case 'locationFields':
        newName = getLocationName(defaultName)
        break

      case 'tenantInfoFields':
        newName = getTenantInfoName(defaultName)
        break

      case 'listingStatusFields':
        newName = getListingsName(defaultName)
        break

      default:
        newName = defaultName

    }

    return newName
  }

  const showBadge = item => {
    let returnVal = false
    if (searchCriteria[item].length > 0) {
      returnVal = true
    }

    return returnVal
  }

  return (
    <>
      <button data-testid={`test-popover-button-${name}`} onClick={handleClick}
        className={`btn btn-sm hover:text-white py-1 ${isCriteriaSelected(name) ? 'btn-primary btn-outline-primary bg-gray-15' : 'bg-white'} ${btnVariant ? 'border-1 border-base' : ''}`} >
        {/* {startIcon && <span className="px-1">{startIconToLoad}</span>} */}
        {startIcon && isCriteriaSelected(name) ? <span className="px-1">{startIconToLoad}</span> : null}
        <span className="px-2">
          {/* {name} */}
          {getFilterName(name)}
        </span>
        <span >{endIconToLoad}</span>
      </button>
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose} maxWidth={'md'}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
        <div className="" >
          <div className="flex flex-col">
            <div>
              <div className="flex justify-between px-6 py-4 border-b-1 border-base">
                <div>
                  {startIconToLoad ? <span className="pr-2">
                    {startIconToLoad}
                  </span> : null}
                  {name}
                </div>
                <div>
                  <a data-testid={`test-close-${name}`} onClick={handleClose}> <ClearOutlinedIcon /> </a>
                </div>
              </div>
            </div>
            <div className="py-4 px-6 overflow-y-auto popover-w disable-scrollbars">
              {listOfFilter[filterName]}
            </div>
          </div>
          <div className="border-t-1 border-base">
            <SubmitClearFilters handleClose={handleClose} criteriaToApply={listSearchCriterias[name]}></SubmitClearFilters>
          </div>
        </div>
      </Popover>
    </>
  )
}

export default FilterPopover

FilterPopover.propTypes = {
  name: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  btnVariant: PropTypes.string
}
